import PropTypes from 'prop-types'

import Body from './body'
import Header from './header'
import Breadcrumb from './breadcrumb'

const Detail = ({ course, integrationSettings, ...attrs }) => {
  return <>
    <Header
      course={course}
      integrationSettings={integrationSettings} />
    <Body
      course={course} />
    <Breadcrumb
      course={course} />
  </>
}

Detail.propTypes = {
  course: PropTypes.object,
  integrationSettings: PropTypes.object
}

export default Detail
